module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employment-templates text-dark"
  }, [_c('div', {
    staticClass: "employment-templates__header"
  }, [_c('h2', [_vm._v("Stillingskategorier")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("\n      Opret stillingskategori\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader')], 1) : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Lønkode ved vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Omkostningssted ved vikarløn ")]), _vm._v(" "), _c('th', [_vm._v("UV-grænse")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('th', [_vm._v("Spec-skole lønkode")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  })])]), _vm._v(" "), _c('tbody', [(_vm.templates.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.emptyColspan
    }
  }, [_c('i', [_vm._v("Ingen stillingskategorier oprettet")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.templates), function(tpl) {
    return _c('tr', {
      key: tpl.id
    }, [_c('td', [_vm._v(_vm._s(tpl.title))]), _vm._v(" "), _c('td', [(tpl.manual_salary) ? _c('span', {
      staticClass: "do-pill do-pill--small do-pill--yellow"
    }, [_vm._v("Vikarløn")]) : _c('span', {
      staticClass: "muted"
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', [(tpl.manual_salary) ? [(_vm.salaryCodeTitle(tpl.salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.salary_code_id)))]) : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])] : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(tpl.omkostningssted) ? [(_vm.costCenterTitle(tpl.omkostningssted)) ? _c('span', [_vm._v(_vm._s(_vm.costCenterTitle(tpl.omkostningssted)))]) : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])] : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(!tpl.manual_salary && tpl.hour_limit) ? [_vm._v("\n          " + _vm._s(tpl.hour_limit) + "\n        ")] : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])], 2), _vm._v(" "), _c('td', [(!tpl.manual_salary && tpl.hour_limit_salary_code_id) ? [(_vm.salaryCodeTitle(tpl.hour_limit_salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.hour_limit_salary_code_id)))]) : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])] : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])], 2), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('td', [(!tpl.manual_salary && tpl.special_hour_limit_salary_code_id) ? [(_vm.salaryCodeTitle(tpl.special_hour_limit_salary_code_id)) ? _c('span', [_vm._v(_vm._s(_vm.salaryCodeTitle(tpl.special_hour_limit_salary_code_id)))]) : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])] : _c('i', {
      staticClass: "muted"
    }, [_vm._v("—")])], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "icon__bg-circle",
      attrs: {
        "title": "Redigér"
      },
      on: {
        "click": function($event) {
          return _vm.openEdit(tpl)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })])])])
  })], 2)]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
    attrs: {
      "theEditEmploymentTemplate": _vm.editTemplate
    },
    on: {
      "created": _vm.onTemplateCreated,
      "updated": _vm.onTemplateUpdated,
      "deleted": _vm.onTemplateDeleted,
      "close": _vm.closeTemplateModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25cfadf3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/EmploymentTemplates.vue
// module id = 1812
// module chunks = 1